export default "__VITE_ASSET__339c5d2a__"